import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function RescheduleConfirmation() {
  const { appointmentId, proposalId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('pending');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const confirmReschedule = async () => {
      try {
        const res = await fetch(
          `https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/appointments/${appointmentId}/reschedule/${proposalId}`,
          { method: 'GET' }
        );

        if (res.ok) {
          setStatus('success');
          setMessage('Votre rendez-vous a été reprogrammé avec succès.');
        } else {
          const error = await res.json();
          setStatus('error');
          setMessage(error.error || 'Erreur lors de la reprogrammation.');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Erreur de connexion avec le serveur.');
      }
    };

    confirmReschedule();
  }, [appointmentId, proposalId]);

  const handleGoToDashboard = () => {
    navigate('/patient/rendez-vous'); // 🔥 Ou vers la page souhaitée
  };

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      {status === 'pending' && <h2>⏳ Traitement en cours...</h2>}
      {status === 'success' && (
        <>
          <h2 style={{ color: 'green' }}>✅ Confirmation réussie</h2>
          <p>{message}</p>
          <button
            onClick={handleGoToDashboard}
            style={{
              padding: '10px 20px',
              backgroundColor: '#4CAF50',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Voir mes rendez-vous
          </button>
        </>
      )}
      {status === 'error' && (
        <>
          <h2 style={{ color: 'red' }}>❌ Une erreur est survenue</h2>
          <p>{message}</p>
          <button
            onClick={handleGoToDashboard}
            style={{
              padding: '10px 20px',
              backgroundColor: '#1e88e5',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer'
            }}
          >
            Retourner à mes rendez-vous
          </button>
        </>
      )}
    </div>
  );
}

export default RescheduleConfirmation;